import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { CardLinkOffersQuery } from '../card-link-offers/card-link-offers.query';
import { FidelService } from '../provider/service/fidel/fidel.service';
import { CardLinkingStore } from './card-linking.store';

@Injectable({ providedIn: 'root' })
export class CardLinkingService {
  constructor(
    private cardLinkingStore: CardLinkingStore,
    private fidelService: FidelService,
    private cardLinkOffersQuery: CardLinkOffersQuery
  ) {}

  /* 
   Fetch the list of linked cards from the api and then set the result into the store
  */

  fetchFidelLinkedCard() {
    return this.fidelService.getcards().pipe(tap((cardsLinked) => this.cardLinkingStore.set(cardsLinked)));
  }

  /**
   * Delete the linked Card.
   * also remove the card from store
   * @param cardId select card id.
   */

  deleteCard(cardID: string) {
    return this.fidelService.deletecard(cardID).pipe(
      tap(() => {
        this.cardLinkingStore.remove(cardID);
        this.cardLinkOffersQuery.deactivateFidelOffersState();
      })
    );
  }
}
